// irrigation-calculator.js

// Load jsPDF library
const script = document.createElement('script');
script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
script.onload = () => console.log('jsPDF loaded successfully');
document.head.appendChild(script);

class IrrigationCalculator {
  constructor() {
    this.config = {
      boomLength: 30,
      boomWidth: 8,
      sprayType: 'single',
      controlType: 'basic',
      sideNozzles: 4,
      options: []
    };
    this.pricing = this.initializePricing();
    this.currentBreakdown = [];
    this.currentTotal = 0;
    
    // Company details - UPDATE THESE WITH YOUR INFORMATION
    this.companyInfo = {
      name: "TERAN AGRI LTD",
      address: "7065 Golyamo Vranovo , 7 Panayot Hitov str.",
      phone: "+359882026252",
      email: "info@teranagri.com",
      website: "www.teranagri.com",
      vatNumber: "VAT: BG205743771" // Add if applicable
    };
    
    this.init();
  }

  initializePricing() {
    return {
      // MANDATORY: Main Construction (Table1)
      mainConstruction: {
        carryingRail: { price: 45, unit: 'm', calc: (l, w) => Math.ceil(l / 3) },
        connectingElement: { price: 12, unit: 'pcs', calc: (l, w, comps) => Math.ceil(l/2) },
        boltM6x120: { price: 1.5, unit: 'pcs', calc: (l, w, comps) => comps.connectingElement * 4 },
        stopNutM6: { price: 0.013, unit: 'pcs', calc: (l, w, comps) => comps.boltM6x120 },
        washerM6: { price: 0.01, unit: 'pcs', calc: (l, w, comps) => comps.boltM6x120 },
        boltM16x100: { price: 2, unit: 'pcs', calc: (l, w, comps) => comps.connectingElement },
        nutM16: { price: 0.12, unit: 'pcs', calc: (l, w, comps) => comps.boltM6x120 * 2 },
        hangingTube: { price: 3, unit: 'm', calc: (l, w, comps) => comps.connectingElement + 4 },
        hangingForming: { price: 2, unit: 'pcs', calc: (l, w, comps) => comps.hangingTube },
        boltM6x20: { price: 0.1, unit: 'pcs', calc: (l, w, comps) => comps.hangingForming * 2 },
        nutM6Small: { price: 0.01, unit: 'pcs', calc: (l, w, comps) => comps.hangingForming },
        washerM6Small: { price: 0.01, unit: 'pcs', calc: (l, w, comps) => comps.hangingForming * 2 },
        grippingElement: { price: 5.3, unit: 'pcs', calc: (l, w, comps) => comps.connectingElement + 4 },
        motorGripping: { price: 200, unit: 'pcs', fixed: 1 },
        parasiticCartPlate: { price: 7.5, unit: 'pcs', calc: (l, w) => Math.ceil(l / 2.5) },
        bearing699: { price: 2.9, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate * 2 },
        polyamideRoller: { price: 13.5, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate *2 },
        rollerAxis: { price: 2.5, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate *2 },
        boltM6x20Roller: { price: 0.1, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate *2 },
        federWasher: { price: 0.02, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate },
        bottomAxis: { price: 4, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate },
        bottomAxisTube: { price: 1, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate },
        hoseClamp: { price: 2, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate },
        boltM8: { price: 0.1, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate },
        nutM8: { price: 0.1, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate },
        washerM8: { price: 0.02, unit: 'pcs', calc: (l, w, comps) => comps.parasiticCartPlate * 2 },
        grippingClamps: { price: 3.9, unit: 'pcs', calc: (l, w, comps) => comps.hangingForming * 2 },
        boltM6x15: { price: 0.1, unit: 'pcs', calc: (l, w, comps) => comps.grippingClamps },
        nutM6Gripping: { price: 0.02, unit: 'pcs', calc: (l, w, comps) => comps.grippingClamps },
        mainWheels: { price: 7, unit: 'pcs', fixed: 8 },
        bearing62300: { price: 4.6, unit: 'pcs', calc: (l, w, comps) => comps.mainWheels },
        fittHose: { price: 7.82, unit: 'm', calc: (l, w) => Math.ceil(l / 2.5) * 4 },
        reinforcedHose: { price: 4.5, unit: 'm', calc: (l, w, comps) => comps.parasiticCartPlate * 0.5 },
        steelCable: { price: 0.6, unit: 'm', calc: (l, w) => l * 2 },
        mainRoller: { price: 30, unit: 'pcs', fixed: 1 },
        mainRollerShaft: { price: 30, unit: 'pcs', fixed: 1 },
        bearingUCP205: { price: 9, unit: 'pcs', fixed: 1 },
        parasiticRoller: { price: 25, unit: 'pcs', fixed: 1 },
        bearing6304: { price: 2.5, unit: 'pcs', fixed: 1 },
        reducer: { price: 180, unit: 'pcs', fixed: 1 },
        galvanizing: { price: 1.5, unit: 'pcs', calc: (l, w) => 6 * l },
        manufacturing: { price: 200, unit: 'pcs', fixed: 1 },
        documentation: { price: 50, unit: 'pcs', fixed: 1 }
      },

      // OPTIONAL: Single Spray Boom (Table2)
      singleSpray: {
        stainlessPipe: { price: 15, unit: 'm', calc: (l, w) => w },
        nozzleHolder: { price: 7.2, unit: 'pcs', calc: (l, w) => Math.ceil(w / 0.5) },
        nozzle: { price: 2.8, unit: 'pcs', calc: (l, w, comps) => comps.nozzleHolder },
        compressionTee: { price: 8, unit: 'pcs', fixed: 1 },
        pressureRegulator: { price: 15, unit: 'pcs', fixed: 1 },
        manometer: { price: 15, unit: 'pcs', fixed: 1 }
      },

      // OPTIONAL: Double Spray Boom (Table3)
      doubleSpray: {
        stainlessPipe: { price: 15, unit: 'm', calc: (l, w) => w * 2 },
        nozzleHolder: { price: 7.2, unit: 'pcs', calc: (l, w) => Math.ceil(w / 0.5) },
        nozzle: { price: 2.8, unit: 'pcs', calc: (l, w, comps) => comps.nozzleHolder },
        compressionTee: { price: 8, unit: 'pcs', fixed: 2 },
        pressureRegulator: { price: 15, unit: 'pcs', fixed: 1 },
        manometer: { price: 15, unit: 'pcs', fixed: 1 }
      },

      // OPTIONAL: Basic Control System (Table4)
      basicControl: {
        servoController: { price: 650, unit: 'pcs', fixed: 1 },
        fuse: { price: 10, unit: 'pcs', fixed: 1 },
        potentiometer: { price: 10, unit: 'pcs', fixed: 1 },
        endSwitch: { price: 25, unit: 'pcs', fixed: 14 },
        cable: { price: 1.2, unit: 'm', calc: (l, w) => l },
        controller: { price: 250, unit: 'pcs', fixed: 1 }
      },

      // OPTIONAL: Advanced Control System (Table46)
      advancedControl: {
        servoController: { price: 600, unit: 'pcs', fixed: 1 },
        hmi: { price: 600, unit: 'pcs', fixed: 1 },
        fuse: { price: 10, unit: 'pcs', fixed: 1 },
        powerSupply: { price: 70, unit: 'pcs', fixed: 1 },
        endSwitch: { price: 60, unit: 'pcs', fixed: 14 },
        cable: { price: 1.2, unit: 'm', calc: (l, w) => l },
        flowMeter: { price: 75, unit: 'pcs', fixed: 0 },
        controller: { price: 400, unit: 'pcs', fixed: 1 }
      },

      // Optional Add-ons (Table467)
      options: {
        dosatron: { price: 300, unit: 'pcs', fixed: 1 },
        dosatronControl: { price: 200, unit: 'pcs', fixed: 1 },
        pump: { price: 400, unit: 'pcs', fixed: 1 }
      },

      // Side Nozzles Pricing (now optional)
      sideNozzles: { price: 50, unit: 'pcs' }
    };
  }

  init() {
    this.bindEvents();
    this.calculatePrice();
  }

  bindEvents() {
    // ... (keep all your existing bindEvents code exactly as it was)
    document.getElementById('boomLength').addEventListener('input', (e) => {
      this.config.boomLength = parseInt(e.target.value) || 30;
      this.calculatePrice();
    });

    document.getElementById('boomWidth').addEventListener('input', (e) => {
      this.config.boomWidth = parseInt(e.target.value) || 8;
      this.calculatePrice();
    });

    document.querySelectorAll('input[name="sprayType"]').forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.config.sprayType = e.target.value;
        this.calculatePrice();
      });
    });

    document.querySelectorAll('input[name="controlType"]').forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.config.controlType = e.target.value;
        this.calculatePrice();
      });
    });

    document.getElementById('sideNozzles').addEventListener('change', (e) => {
      this.config.sideNozzles = parseInt(e.target.value);
      this.calculatePrice();
    });

    document.querySelectorAll('input[name="options"]').forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.config.options.push(e.target.value);
        } else {
          this.config.options = this.config.options.filter(opt => opt !== e.target.value);
        }
        this.calculatePrice();
      });
    });

    // Download buttons
    document.getElementById('downloadText').addEventListener('click', () => this.downloadText());
    document.getElementById('downloadPDF').addEventListener('click', () => this.downloadPDF());
  }

  calculateComponentPrice(componentConfig, length, width) {
    // ... (keep all your existing calculateComponentPrice code exactly as it was)
    let total = 0;
    const quantities = {};
    
    for (const [key, config] of Object.entries(componentConfig)) {
      let quantity = 0;
      
      if (config.fixed !== undefined) {
        quantity = config.fixed;
      } else if (config.calc) {
        quantity = config.calc(length, width, quantities);
      }
      
      quantities[key] = quantity;
      total += quantity * config.price;
    }
    
    return Math.round(total * 100) / 100;
  }

  calculatePrice() {
    // ... (keep all your existing calculatePrice code exactly as it was)
    let total = 0;
    const breakdown = [];
    const l = this.config.boomLength;
    const w = this.config.boomWidth;

    const mainConstructionPrice = this.calculateComponentPrice(this.pricing.mainConstruction, l, w) * 0.75;
    total += mainConstructionPrice ;
    breakdown.push(`Основна конструкция: €${mainConstructionPrice}`);

    let sprayTypeName = '';
    let sprayPrice = 0;
    if (this.config.sprayType === 'single') {
      sprayPrice = this.calculateComponentPrice(this.pricing.singleSpray, l, w) * 0.75;
      sprayTypeName = 'Единична щанга';
    } else {
      sprayPrice = this.calculateComponentPrice(this.pricing.doubleSpray, l, w) * 0.75;
      sprayTypeName = 'Двойна щанга';
    }
    total += sprayPrice;
    breakdown.push(`${sprayTypeName}: €${sprayPrice}`);

    let controlTypeName = '';
    let controlPrice = 0;
    if (this.config.controlType === 'basic') {
      controlPrice = this.calculateComponentPrice(this.pricing.basicControl, l, w) * 0.75;
      controlTypeName = 'Управление Вариант 1';
    } else {
      controlPrice = this.calculateComponentPrice(this.pricing.advancedControl, l, w) * 0.75;
      controlTypeName = 'Управление Вариант 2';
    }
    total += controlPrice ;
    breakdown.push(`${controlTypeName}: €${controlPrice}`);

    if (this.config.sideNozzles > 0) {
      const sideNozzlesPrice = this.config.sideNozzles * this.pricing.sideNozzles.price;
      total += sideNozzlesPrice ;
      breakdown.push(`${this.config.sideNozzles} Странично дюзи : €${sideNozzlesPrice}`);
    }

    this.config.options.forEach(option => {
      const optionPrice = this.pricing.options[option].price * (this.pricing.options[option].fixed || 1);
      total += optionPrice;
      breakdown.push(`${this.getOptionName(option)}: €${optionPrice}`);
    });

    this.currentBreakdown = breakdown;
    this.currentTotal = total;

    this.updateDisplay(total, breakdown);
  }

  getOptionName(option) {
    // ... (keep your existing getOptionName code)
    const names = {
      dosatron: 'Прецизен дозатор за торовнасяне/ПРЗ',
      dosatronControl: 'Безжична система за контрол на дозатора',
      pump: 'Помпа за високо налягане'
    };
    return names[option] || option;
  }

  updateDisplay(total, breakdown) {
    // ... (keep your existing updateDisplay code)
    document.getElementById('totalPrice').textContent = total.toFixed(2);
    
    const breakdownEl = document.getElementById('priceBreakdown');
    breakdownEl.innerHTML = breakdown.map(item => 
      `<div class="breakdown-item">${item}</div>`
    ).join('');
  }

  downloadText() {
    // ... (keep your existing downloadText code exactly as it was)
    if (!this.currentBreakdown.length) {
      alert('Please configure the irrigation boom first');
      return;
    }

    const config = this.config;
    const total = this.currentTotal;
    const breakdown = this.currentBreakdown;
    
    const text = `GREENHOUSE IRRIGATION BOOM CONFIGURATION
Generated: ${new Date().toLocaleString()}
=============================================

BOOM DIMENSIONS:
• Length: ${config.boomLength} meters
• Width: ${config.boomWidth} meters

CONFIGURATION OPTIONS:
• Spray Boom: ${config.sprayType === 'single' ? 'Single Spray Boom' : 'Double Spray Boom'}
• Control System: ${config.controlType === 'basic' ? 'Basic Control System' : 'Advanced Control System (HMI)'}
• Side Nozzles: ${config.sideNozzles} pieces
${config.options.length > 0 ? '• Additional Options:\n' + config.options.map(opt => `  - ${this.getOptionName(opt)}`).join('\n') + '\n' : ''}
PRICE BREAKDOWN:
${breakdown.map(item => `• ${item}`).join('\n')}

TOTAL PRICE (excl. VAT): €${total.toFixed(2)}

CONTACT INFORMATION:
For questions or to place an order, please contact us with this configuration reference.

CONFIGURATION REFERENCE:
Boom-${config.boomLength}x${config.boomWidth}-${config.sprayType.charAt(0)}-${config.controlType.charAt(0)}-SN${config.sideNozzles}${config.options.length > 0 ? '-' + config.options.map(opt => opt.charAt(0)).join('') : ''}`;

    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `irrigation-config-${new Date().toISOString().slice(0, 10)}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  downloadPDF() {
    if (!this.currentBreakdown.length) {
      alert('Please configure the irrigation boom first');
      return;
    }

    // Check if jsPDF is loaded
    if (typeof window.jspdf === 'undefined') {
      alert('PDF library is still loading. Please try again in a moment.');
      return;
    }

    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();
    
    const config = this.config;
    const total = this.currentTotal;
    const breakdown = this.currentBreakdown;
    
    let yPosition = 20;
    
    // Company Header
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(44, 90, 160); // Company color
    doc.text(this.companyInfo.name, 105, yPosition, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0); // Black
    doc.text(this.companyInfo.address, 105, yPosition + 8, { align: 'center' });
    doc.text(`Tel: ${this.companyInfo.phone} | Email: ${this.companyInfo.email}`, 105, yPosition + 16, { align: 'center' });
    doc.text(this.companyInfo.website, 105, yPosition + 24, { align: 'center' });
    
    yPosition = 55;
    
    // Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(44, 90, 160);
    doc.text('IRRIGATION BOOM QUOTATION', 105, yPosition, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text(`Quotation Date: ${new Date().toLocaleDateString()}`, 105, yPosition + 8, { align: 'center' });
    doc.text(`Reference: Boom-${config.boomLength}x${config.boomWidth}-${config.sprayType.charAt(0)}-${config.controlType.charAt(0)}-SN${config.sideNozzles}${config.options.length > 0 ? '-' + config.options.map(opt => opt.charAt(0)).join('') : ''}`, 105, yPosition + 16, { align: 'center' });
    
    yPosition += 30;
    
    // Customer Information Section
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('CUSTOMER QUOTATION', 20, yPosition);
    
    yPosition += 10;
    doc.setDrawColor(200, 200, 200);
    doc.line(20, yPosition, 190, yPosition);
    yPosition += 15;
    
    // Configuration Details
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('Configuration Details:', 20, yPosition);
    
    doc.setFont('helvetica', 'normal');
    doc.text(`• Boom Dimensions: ${config.boomLength}m × ${config.boomWidth}m`, 25, yPosition + 8);
    doc.text(`• Spray Boom Type: ${config.sprayType === 'single' ? 'Single Spray Boom' : 'Double Spray Boom'}`, 25, yPosition + 16);
    doc.text(`• Control System: ${config.controlType === 'basic' ? 'Basic Control System' : 'Advanced Control System (HMI)'}`, 25, yPosition + 24);
    doc.text(`• Side Nozzles: ${config.sideNozzles} pieces`, 25, yPosition + 32);
    
    if (config.options.length > 0) {
      doc.text('• Additional Options:', 25, yPosition + 40);
      config.options.forEach((option, index) => {
        doc.text(`  - ${this.getOptionName(option)}`, 30, yPosition + 48 + (index * 8));
      });
      yPosition += 48 + (config.options.length * 8);
    } else {
      yPosition += 40;
    }
    
    yPosition += 20;
    
    // Price Breakdown Table Header
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.setFillColor(44, 90, 160);
    doc.rect(20, yPosition, 170, 8, 'F');
    doc.text('DESCRIPTION', 25, yPosition + 6);
    doc.text('AMOUNT', 170, yPosition + 6, { align: 'right' });
    
    yPosition += 15;
    
    // Price Breakdown Items
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    
    breakdown.forEach((item, index) => {
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
        
        // Table header on new page
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(255, 255, 255);
        doc.setFillColor(44, 90, 160);
        doc.rect(20, yPosition, 170, 8, 'F');
        doc.text('DESCRIPTION', 25, yPosition + 6);
        doc.text('AMOUNT', 170, yPosition + 6, { align: 'right' });
        yPosition += 15;
      }
      
      const [description, amount] = item.split(': €');
      doc.text(description, 25, yPosition + (index * 8));
      doc.text(`€${amount}`, 170, yPosition + (index * 8), { align: 'right' });
    });
    
    yPosition += (breakdown.length * 8) + 15;
    
    // Total Price
    doc.setDrawColor(44, 90, 160);
    doc.setLineWidth(0.5);
    doc.line(120, yPosition, 190, yPosition);
    
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text('TOTAL (excl. VAT):', 90, yPosition + 8);
    doc.text(`€${total.toFixed(2)}`, 170, yPosition + 8, { align: 'right' });
    
    yPosition += 25;
    
    // Footer
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text('This quotation is valid for 30 days from the date of issue.', 105, 270, { align: 'center' });
    doc.text('For questions or to place an order, please contact us with the reference number above.', 105, 275, { align: 'center' });
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 105, 280, { align: 'center' });
    
    // Save PDF
    const filename = `irrigation-boom-quotation-${config.boomLength}x${config.boomWidth}-${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(filename);
  }
}

// Initialize calculator
document.addEventListener('DOMContentLoaded', () => {
  new IrrigationCalculator();
});
